<script setup>
import AppIcon from '@/components/app/AppIcon.vue'
const expanded = ref(false)
</script>
<template>
  <div class="wrapper">
    <div class="content" :class="{ expanded }">
      <div class="handle-wrapper">
        <div class="handle" @click="expanded = !expanded">
          <AppIcon :icon="expanded ? 'ChevronDownIcon' : 'ChevronUpIcon'" class="icon" />
        </div>
      </div>
      <slot name="content"></slot>
    </div>
    <div class="map">
      <slot name="map"></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import 'App.scss';
.wrapper {
  display: flex;
  height: 100%;
  margin: 0;
  flex-flow: column-reverse;
}

.handle-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: -48px;
  background-color: #fff;
  margin-top: -48px;
  z-index: 1;
}
.handle {
  .icon {
    width: 24px;
  }
}
.content {
  position: relative;
  padding: 24px;
  padding-top: 48px;
  height: 100%;
  width: 100%;
  z-index: 1;
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  flex: 1;
  border-bottom: 1px solid #e5e5e5;
  overflow-y: scroll;
  transition: all 0.7s ease;
  &.expanded {
    flex: 10;
  }
}
.map {
  height: 100%;
  width: 100%;
  padding: 0;
  flex: 3;
}
@include desktop-up() {
  .wrapper {
    flex-flow: row;
  }
  .content {
    flex: 1;
    max-width: 600px;
    padding-top: 24px;
  }
  .map {
    flex: 1;
  }
  .handle-wrapper {
    display: none;
  }
}
</style>
